import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
    return ['form', 'rowCheckbox'];
  }


  initialize(){

  }


  submit(e){
    e.preventDefault();
    this.formTarget.submit();
  }

  reRenderSelf(e){

    if (e.detail[2]){
     var returnHtml = e.detail[2].response;
    }
    else {
    var returnHtml = e.detail[0].response;

    }
    let parent = this.element.parentNode;
    this.element.remove();
    parent.innerHTML = returnHtml;
  }



  selectedRows(){
    let rows = [];
    this.rowCheckboxTargets.forEach(function(el){
      if (el.checked){
      rows.push(el.parentNode.parentNode);
      }
    })

    return rows;
  }

  toggleAllRows(e){

    let checked = e.target.checked;

    this.rowCheckboxTargets.forEach(function(el){
      el.checked = checked;
    })
  }
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/form_controller.js